import axios from 'axios'
import config from '../config';

import { getQueryStringFromObject, getRequestHeaders } from './common.service';

const getBarList = async (query=null) => {
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/bars' + queryString, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getBarDetails = async (bar_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v2/bars/' + bar_id, { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getBarConsumptions = async (bar_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/bars/' + bar_id + '/consumptions', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const addBarConsumption = async (bar_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/bars/' + bar_id + '/consumptions/new', data, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const reoderBarConsumptions = async (bar_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v1/bars/' + bar_id + '/consumptions/reorder', data, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getBarPossibleDeposits = async (bar_id) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/v1/bars/' + bar_id + '/possible_deposits', { headers: headers });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const addBarPossibleDeposits = async (bar_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/bars/' + bar_id + '/possible_deposits/new', data, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const removeBarPossibleDeposits = async (bar_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/bars/' + bar_id + '/possible_deposits/remove', data, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const swapBarPossibleDeposits = async (bar_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.post( config.apiUrl + '/v1/bars/' + bar_id + '/possible_deposits/swap', data, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const reorderBarPossibleDeposits = async (bar_id, data) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.put( config.apiUrl + '/v1/bars/' + bar_id + '/possible_deposits/reorder', data, { headers: headers });
        } catch (error) {
            return { error: error.response.data };
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getBarPossibleDepositReturns = async (bar_id) => {
    try {
        let headers = getRequestHeaders();
        const response = await axios.get(`${config.apiUrl}/v1/bars/${bar_id}/possible_deposit_returns`, { headers });
        return response.data;
    } catch (error) {
        return error.response?.data || { error: error.message };
    }
};

const addBarPossibleDepositReturns = async (bar_id, data) => {
    try {
        let headers = getRequestHeaders();
        const response = await axios.post(`${config.apiUrl}/v1/bars/${bar_id}/possible_deposit_returns/new`, data, { headers });
        return response.data;
    } catch (error) {
        return error.response?.data || { error: error.message };
    }
};

const removeBarPossibleDepositReturns = async (bar_id, data) => {
    try {
        let headers = getRequestHeaders();
        const response = await axios.post(`${config.apiUrl}/v1/bars/${bar_id}/possible_deposit_returns/remove`, data, { headers });
        return response.data;
    } catch (error) {
        return error.response?.data || { error: error.message };
    }
};

const swapBarPossibleDepositReturns = async (bar_id, data) => {
    try {
        let headers = getRequestHeaders();
        const response = await axios.post(`${config.apiUrl}/v1/bars/${bar_id}/possible_deposit_returns/swap`, data, { headers });
        return response.data;
    } catch (error) {
        return error.response?.data || { error: error.message };
    }
};

const reorderBarPossibleDepositReturns = async (bar_id, data) => {
    try {
        let headers = getRequestHeaders();
        const response = await axios.put(`${config.apiUrl}/v1/bars/${bar_id}/possible_deposit_returns/reorder`, data, { headers });
        return response.data;
    } catch (error) {
        return error.response?.data || { error: error.message };
    }
};

export {
    getBarList,
    getBarDetails,
    getBarConsumptions,
    addBarConsumption,
    reoderBarConsumptions,
    getBarPossibleDeposits,
    addBarPossibleDeposits,
    reorderBarPossibleDeposits,
    removeBarPossibleDeposits,
    swapBarPossibleDeposits,
    getBarPossibleDepositReturns,
    addBarPossibleDepositReturns,
    reorderBarPossibleDepositReturns,
    removeBarPossibleDepositReturns,
    swapBarPossibleDepositReturns    
}
